import DateUtils from '../../../../core/services/date-utils';
import {PredefinedDateRange, PredefinedDateRangeGroup} from './types';

/**
 * A registry of common date range presets.
 */
export class PredefinedDateRanges {

    static readonly allGroups: Record<string, PredefinedDateRangeGroup> = {
        accounting: {
            title: "Accounting",
            id: "accounting",
        } as PredefinedDateRangeGroup,
    }

    static readonly ACCOUNTING_LESS_THAN_30: PredefinedDateRange = {
        id: 'accounting-less-than-30',
        title: 'Less than 30',
        group: PredefinedDateRanges.allGroups.accounting.id,
        getDateRange: () => [
            DateUtils.local().subtract(30, 'days').startOf('day'),
            DateUtils.local()
        ]
    };

    static readonly ACCOUNTING_OVER_30: PredefinedDateRange = {
        id: 'accounting-over-30',
        title: 'Over 30',
        group: PredefinedDateRanges.allGroups.accounting.id,
        getDateRange: () => [
            DateUtils.local().subtract(60, 'days').startOf('day'),
            DateUtils.local().subtract(30, 'days').endOf('day')
        ]
    };

    static readonly ACCOUNTING_OVER_60: PredefinedDateRange = {
        id: 'accounting-over-60',
        title: 'Over 60',
        group: PredefinedDateRanges.allGroups.accounting.id,
        getDateRange: () => [
            DateUtils.local().subtract(90, 'days').startOf('day'),
            DateUtils.local().subtract(60, 'days').endOf('day')
        ]
    };

    static readonly ACCOUNTING_OVER_90: PredefinedDateRange = {
        id: 'accounting-over-90',
        title: 'Over 90',
        group: PredefinedDateRanges.allGroups.accounting.id,
        getDateRange: () => [
            DateUtils.local().subtract(120, 'days').startOf('day'),
            DateUtils.local().subtract(90, 'days').endOf('day')
        ]
    };

    static readonly ACCOUNTING_OVER_120: PredefinedDateRange = {
        id: 'accounting-over-120',
        title: 'Over 120',
        group: PredefinedDateRanges.allGroups.accounting.id,
        getDateRange: () => [
            undefined, // Nothing (unbounded past)
            DateUtils.local().subtract(120, 'days').endOf('day')
        ]
    };

    /**
     * The standard list of accounting-related presets.
     */
    static readonly accountingRanges = [
        PredefinedDateRanges.ACCOUNTING_LESS_THAN_30,
        PredefinedDateRanges.ACCOUNTING_OVER_30,
        PredefinedDateRanges.ACCOUNTING_OVER_60,
        PredefinedDateRanges.ACCOUNTING_OVER_90,
        PredefinedDateRanges.ACCOUNTING_OVER_120,
    ];

    static readonly allRanges = [
        ...PredefinedDateRanges.accountingRanges,
        // Add future presets here
    ];
}

export const DEFAULT_PREDEFINED_RANGES = PredefinedDateRanges.accountingRanges;
